
const Sources = [
  { key: 0, name: 'QORE' },
  { key: 1, name: 'LEGACY' },
  { key: 2, name: 'ECP' },
  { key: 3, name: 'VENDOR' }
]

export const getClaimSourceKeyFor = (claimSource) => {
  if (!claimSource) return;

  let source = Sources.find(source => source.name === claimSource.toUpperCase());
  return source.key;
}

export const getClaimSourceNameFor = (key) => {
  let source = Sources.find(source => source.key == key);
  return source.name;
}